import React, { useEffect, useState } from "react";

import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
  GetAllRecharge,
} from "../../../../features/admin/recharge_management/recharge/Slice";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { Controller, useForm } from "react-hook-form";

import {
  getAllCities,
  getAllCitiesWithoutType,
  getAllVehicleCatWithoutType,
} from "../../../../features/admin/common/Slice";
import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";
import Add_section_title from "../../../common-components/add-section-title/Add_section_title";
const Add = ({ id, setId, setShowError, setSuccess, setErr }) => {
  const [modalShow, setModalShow] = React.useState(false);
  const dispatch = useDispatch();

  const vehicleList = useSelector(
    (state) => state.common.all_vehicle_category_without_type,
  );

  const cities = useSelector((state) => state.common.all_cities_without_type);

  const selectAllOption = { label: "Select All", value: "all" };

  const districtList = id
    ? cities // ✅ only when id exists
    : [selectAllOption, ...cities];

  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    setError,
    getValues,
    control,
    watch,
    formState: { errors },
    reset,
    image_required = true,
  } = useForm();
  const imageFile = watch("image");

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));
      if (res.meta.requestStatus === "fulfilled") {
        const responseData = res?.payload?.data?.data;
        reset(responseData);

        // Match the type string to the select option object
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    if (id !== "") {
      GetData(id);
    }
  }, [id]);

  const selectedType = watch("type");

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("price", data?.price);
      sendData.append("discount_percent", data?.discount_percent);
      sendData.append("tax_percent", data?.tax_percent);
      sendData.append("expiry_day", data?.expiry_day);
      sendData.append("description", data?.description);

      let response;
      if (id) {
        sendData.append(
          "vehicle_category_id",
          data?.vehicle_category_id?.value,
        );
        sendData.append("district_id", data?.district_id?.value);
        response = await dispatch(Update({ id: id, data: sendData }));
      } else {
        const vehicleIds = data?.vehicle_category_id?.map((v) => v.value);

        sendData.append("vehicle_category_id", JSON.stringify(vehicleIds));

        const districtIds = data?.district_id
          ?.filter((v) => v.value !== "all")
          ?.map((v) => v.value);

        sendData.append("district_id", JSON.stringify(districtIds));

        response = await dispatch(Create(sendData));
      }
      if (response.meta.requestStatus === "fulfilled") {
        await dispatch(GetAllRecharge());
        await setId("");
        setSuccess(true);
        setModalShow(true);
        reset({
          vehicle_category_id: "",
          price: "",
          discount_percent: "",
          tax_percent: "",
          expiry_day: "",
          description: "",
          district_id: "",
        });
        setTimeout(() => {
          setSuccess(false);
          setModalShow(false);
        }, 3000);
      } else if (response.meta?.requestStatus === "rejected") {
        setShowError(response.payload?.response?.data?.errors);
      }

      if (response.payload == 406) {
        await setError("vehicle_category_id", {
          type: "manual",
          message: "Recharge Already Exists",
        });
      }
    } catch (error) {
      setErr(true);
      console.error("error in Add Namee", error);
    }
  };

  useEffect(() => {
    dispatch(getAllVehicleCatWithoutType());
    dispatch(getAllCitiesWithoutType());
  }, [dispatch]);

  return (
    <>
      <Add_section_title
        title={id ? "Edit Recharge" : "Add Recharge"}
        alltotal=""
      />
      <div className="forms_section">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>Vehicle Category</Form.Label>
                {id ? (
                  <Controller
                    name="vehicle_category_id" // name of the field
                    {...register("vehicle_category_id", {
                      required: "Select Vehicle Category",
                    })}
                    control={control}
                    render={({ field }) => (
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.vehicle_category_id
                              ? "red"
                              : baseStyles.borderColor,
                          }),
                        }}
                        {...field}
                        options={vehicleList}
                      />
                    )}
                  />
                ) : (
                  <Controller
                    name="vehicle_category_id" // name of the field
                    {...register("vehicle_category_id", {
                      required: "Select at least one Vehicle Category",
                    })}
                    control={control}
                    render={({ field }) => (
                      <Select
                        isMulti // ✅ ADD THIS
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.vehicle_category_id
                              ? "red"
                              : baseStyles.borderColor,
                          }),
                        }}
                        {...field}
                        options={vehicleList}
                      />
                    )}
                  />
                )}
                {errors.vehicle_category_id && (
                  <span className="text-danger">
                    {errors.vehicle_category_id.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>
                  <b>Price</b>
                </Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Price"
                  min="0"
                  // onInput={(e) => {
                  //   e.target.value = Math.max(
                  //     0,
                  //     e.target.value || 0
                  //   );
                  // }}
                  {...register("price", {
                    required: "Price is Required",
                    min: {
                      value: 0,
                      message: "Price cannot be negative",
                    },
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.price,
                  })}
                />

                {errors.price && (
                  <span className="text-danger">{errors.price?.message}</span>
                )}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>
                  <b>Discount Percent</b>
                </Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Discount Percent"
                  min="0"
                  max="100"
                  {...register("discount_percent", {
                    required: "Discount Percent is Required",
                    min: {
                      value: 0,
                      message: "Discount Percent cannot be negative",
                    },
                    max: {
                      value: 100,
                      message: "Discount Percent cannot be more than 100",
                    },
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.discount_percent,
                  })}
                />
                {errors.discount_percent && (
                  <span className="text-danger">
                    {errors.discount_percent?.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>
                  <b>Tax Percent</b>
                </Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Tax Percent"
                  min="0"
                  max="100"
                  {...register("tax_percent", {
                    required: "Tax Percent is Required",
                    min: {
                      value: 0,
                      message: "Tax Percent cannot be negative",
                    },
                    max: {
                      value: 100,
                      message: "Tax Percent cannot be more than 100",
                    },
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.tax_percent,
                  })}
                />
                {errors.tax_percent && (
                  <span className="text-danger">
                    {errors.tax_percent?.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>
                  <b>Bookings Amount / Publish Counts For Share Taxi</b>
                </Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Bookings Amount / Publish Counts For Share Taxi"
                  min="1"
                  {...register("expiry_day", {
                    required:
                      "Bookings Amount / Publish Counts For Share Taxi is Required",
                    min: {
                      value: 1,
                      message:
                        "Bookings Amount / Publish Counts For Share Taxi cannot be negative",
                    },
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.expiry_day,
                  })}
                />
                {errors.expiry_day && (
                  <span className="text-danger">
                    {errors.expiry_day?.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-lg-6 col-md-6 mb-3">
              <div className="form-group">
                <Form.Label>
                  <b>Description</b>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  placeholder="Description"
                  {...register("description", {
                    required: "Description is Required",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.description,
                  })}
                />
                {errors.description && (
                  <span className="text-danger">
                    {errors.description?.message}
                  </span>
                )}
              </div>
            </div>

            <div className="col-lg-12 col-md-12 mb-3">
              <div className="form-group">
                <Form.Label>District</Form.Label>
                {id ? (
                  <Controller
                    name="district_id" // name of the field
                    {...register("district_id", {
                      required: "Select District",
                    })}
                    control={control}
                    render={({ field }) => (
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.district_id
                              ? "red"
                              : baseStyles.borderColor,
                          }),
                        }}
                        {...field}
                        options={districtList}
                      />
                    )}
                  />
                ) : (
                  <Controller
                    name="district_id"
                    control={control}
                    rules={{
                      required: "Select at least one District",
                    }}
                    render={({ field }) => (
                      <Select
                        isMulti
                        options={districtList}
                        value={field.value}
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.district_id
                              ? "red"
                              : baseStyles.borderColor,
                          }),
                        }}
                        onChange={(selected) => {
                          if (!selected) {
                            field.onChange([]);
                            return;
                          }

                          const isSelectAll = selected.some(
                            (option) => option.value === "all",
                          );

                          if (isSelectAll) {
                            // remove select all option
                            const allDistricts = districtList.filter(
                              (item) => item.value !== "all",
                            );

                            field.onChange(allDistricts);
                          } else {
                            field.onChange(selected);
                          }
                        }}
                      />
                    )}
                  />
                )}
                {errors.district_id && (
                  <span className="text-danger">
                    {errors.district_id.message}
                  </span>
                )}
              </div>
            </div>

            <div className="form_submit_div ">
              <div className="row">
                <div className="col-lg-4 mx-auto mb-3">
                  <div className="button_group">
                    <button
                      type="button"
                      className="closebtn theme_bg"
                      onClick={() => {
                        reset({
                          name: "",
                          vehicle_category_id: "",
                          price: "",
                          discount_percent: "",
                          tax_percent: "",
                          expiry_day: "",
                          description: "",
                          district_id: "",
                        });
                        setId("");
                      }}
                    >
                      Clear
                    </button>
                    <button
                      type="button"
                      className="addbtn"
                      onClick={handleSubmit(onSubmit)}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>

      <Successfull_Modal
        message={"Successful"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Add;
